import React, { useState } from "react";
import * as Icons from "react-feather";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import axios from "axios";
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import { ReactComponent as SortArrow } from '../../shared/img/chevron-up-down.svg'; 
import ClientCompanyTypeModel from "./models/ClientCompanyTypeModel";
import ClientCompanyTypeModal from "./ClientCompanyTypeModal";
import { getStorageValues } from "../../shared/CommonFunctions";
import { getApiBaseUrl } from "../../utils/apiConfig";
import { logAuditEvent } from '../../utils/auditLogger';

function ClientCompanyTypeGrid(props) {
  const [actionType, setActionType] = useState();
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [clientCompanyTypeModel, setClientCompanyTypeModel] = useState(new ClientCompanyTypeModel());
  const [filterText, setFilterText] = React.useState("");
  const [alert, setAlert] = useState(null);
  const moduleName = props.moduleName || 'Client Company Type';

  function closeModal() {
    setIsOpen(false);
    props.fetchClientCompanyType();
  }

  const rows = props.ClientCompanyTypeData
    ? props.ClientCompanyTypeData.filter(
      (item) =>
        (item.ClientCompanyTypeName &&
          item.ClientCompanyTypeName.toLowerCase().includes(filterText.toLowerCase())) ||
        (item.Description &&
          item.Description.toLowerCase().includes(filterText.toLowerCase()))
    )
    : [];

  const openActionType = (row, name) => {
    const detail = row?.ClientCompanyTypeName ? `Client Company Type: ${row.ClientCompanyTypeName}` : '';
    logAuditEvent(moduleName, `${name} Click`, `${name} clicked. ${detail}`.trim());
    setClientCompanyTypeModel(row);
    setIsOpen(true);
    setActionType(name);
  };
  async function onSubmit(e, data) {
    const clientCompanyTypeModel = data;
    if (e.target.name === "Edit") {
      let clientCompanyTypeDetails = {
        ClientCompanyTypeId: clientCompanyTypeModel.ClientCompanyTypeId,
        ClientCompanyTypeName: clientCompanyTypeModel.ClientCompanyTypeName,
        Description: clientCompanyTypeModel.Description,
        UserId: getStorageValues('userId')
      };
      if (validation(clientCompanyTypeDetails)) {
        try {
          const response = await axios.post(
            getApiBaseUrl() + "/saveClientCompanyTypeDetails", 
            clientCompanyTypeDetails
          );
          if (response.status === 200) {
            if (response.data.data[0].success === 1) {
              CreateAlert(response.data.data[0].message, "Success", setAlert);
              props.fetchClientCompanyType();
              closeModal();
            } else {
              CreateAlert(response.data.data[0].message, "Warning", setAlert);
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    } else if(e.target.name === "Delete"){
      let clientCompanyTypeDetails = {
        ClientCompanyTypeId: clientCompanyTypeModel.ClientCompanyTypeId
      };
      try {
        const response = await axios.post(
          getApiBaseUrl() + "/deleteclientcompanytype", clientCompanyTypeDetails
        );
        if (response.status === 200) {
          CreateAlert("Client company type deleted successfully!!", "Success", setAlert);
          props.fetchClientCompanyType();
          closeModal();
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  function validation(clientCompanyTypeDetails) {
    var validation = true;
    if (clientCompanyTypeDetails) {
      if (clientCompanyTypeDetails.ClientCompanyTypeName !== null) {
        if (clientCompanyTypeDetails.ClientCompanyTypeName.length === 0) {
          CreateAlert("Please enter user name!!", "Warning", setAlert);
          validation = false;
        }
      } else {
        CreateAlert("Please enter user name!!", "Warning", setAlert);
        validation = false;
      }
    } else {
      CreateAlert("Some proplem fatching user details entered by the user!!", "Error", setAlert);
      return (validation = false);
    }
    return validation;
  }

  const columns = [
    {
      name:<div className="titlename"><span>Client Company Type </span></div> ,
      selector: row => row.ClientCompanyTypeName,
      cell: (row) => (
        <span title={row.ClientCompanyTypeName}>{row.ClientCompanyTypeName}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
    {
      name: <div className="titlename"><span>Description </span></div>,
      selector: row => row.Description,
      cell: (row) => (
        <span title={row.Description}>{row.Description}</span>
      ),
      sortable: true,
      sortIcon: <SortArrow />
    },
  ];
  if(props.UserPermissions.ViewModule === 1 || props.UserPermissions.EditModule === 1 || props.UserPermissions.DeleteModule === 1){
    columns.push({
      name: <div className="titlename">Actions</div>,
      cell: (row) => (
        <div className="edit-delete-action">
          {
            props.UserPermissions.ViewModule === 1 ? 
              <Link
                className="me-2 p-2"
                to=""
                onClick={() => {
                  openActionType(row, "View");
                }}
              >
                <Icons.Eye data-feather="eye" className="action-eye" />
              </Link>
            : null
          }
          {
            props.UserPermissions.EditModule === 1 ? 
              <Link
                className="me-2 p-2"
                to=""
                onClick={() => {
                  openActionType(row, "Edit");
                }}
              >
                <Icons.Edit data-feather="edit" className="feather-edit" />
              </Link>
            : null
          }
          {
            props.UserPermissions.DeleteModule === 1 ? 
              <Link
                className="confirm-text p-2"
                to=""
                onClick={() => {
                  openActionType(row, "Delete");
                }}
              >
                <Icons.Trash2 data-feather="trash-2" className="feather-trash-2" />
              </Link>
            : null
          }
        </div>
      ),
      center: "true",
      width: "150px"
    },);
  };

  return (
    <>
      <SKAlerts alert={alert} />
      <div className="card table-list-card">
        <div className="card-body">
          <div className="table-top">
            <div className="search-set">
              <div className="search-input">
                <button type="button" className="btn btn-searchset">
                  <Icons.Search className="feather-search" />
                </button>
                <input
                  id="search"
                  type="text"
                  className="form-control form-control-sm custom-search-input"
                  placeholder="Search"
                  aria-label="Search Input"
                  value={filterText}
                  onChange={(e) => setFilterText(e.target.value)}
                />
              </div>
            </div>
          </div>
          <DataTable
            className="table-responsive product-list"
            columns={columns}
            data={rows}
            pagination
            defaultSortField="ClientCompanyTypeName"
            sortIcon={<SortArrow/>}
            persistTableHead={true}
          />
        </div>
      </div>
      <ClientCompanyTypeModal
        show={modalIsOpen}
        UserAction={actionType}
        onClose={closeModal}
        selectedRow={clientCompanyTypeModel}
        onSubmit={onSubmit}
        moduleName={moduleName}
      />
    </>
  );
}

export default ClientCompanyTypeGrid;
